import { Component } from '@angular/core';
import { Router, NavigationEnd  } from '@angular/router';
import { EmitterService } from '../../../shared/services/event-service.service';
import { closeIcon, dashboardIcon, userIcon, unverifiedUser, reportsIcon, subscriptionIcon } from '../../../utils/images';
import { isMobileDevice } from '../../../utils/helper';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
})
export class SidebarComponent {
  public menu: boolean = !isMobileDevice();
  currentRoute: string = this.router.url;
  activeLink: string = 'dashboard';

  collapsedStates: {[key: string]: boolean} = {
    reports: true,
    subscriptions: true
  };

  // Icon assets
  icons = {
    close: closeIcon,
    dashboard: dashboardIcon,
    user: userIcon,
    unverified: unverifiedUser,
    reports: reportsIcon,
    subscription: subscriptionIcon
  };

  constructor (private eventEmitter: EmitterService, private router: Router) {}

  ngOnInit () {
    this.subscribeToSidebarToggle();
    this.trackRouteChanges();
  }

  private subscribeToSidebarToggle(): void {
    this.eventEmitter.listen('sidebar', (menuState: boolean) => {
      this.menu = menuState;
    });
  }

  private trackRouteChanges(): void {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.currentRoute = event.urlAfterRedirects;

        // Auto-close sidebar on mobile after navigation
        if (isMobileDevice()) {
          this.menu = false;
          this.eventEmitter.emit('sidebar', false);
        }
      }
    });
  }

  toggleMenu(event: Event): void {
    event.preventDefault();
    this.menu = !this.menu;
    this.eventEmitter.emit('sidebar', this.menu);
  }

  // Toggle collapse state for a specific section
  toggleCollapse(section: string): void {
    this.collapsedStates[section] = !this.collapsedStates[section];
  }

  // Check if a section is collapsed
  isCollapsed(section: string): boolean {
    return this.collapsedStates[section] ?? true;
  }
}
